// Safari 10 nomodule fix:
if ( window.MAIN_EXECUTED ) {
    throw new Error( '' )
}
window.MAIN_EXECUTED = true

// Polyfills:
import '@babel/polyfill'

// External Dependencies:
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route } from 'react-router-dom'

// Internal Dependencies:
import SiteContainer from 'containers/SiteContainer'

// Redux:
import { Provider } from 'react-redux'
import configureStore from 'store/configure-store'
const store = configureStore()

ReactDOM.render(
	<Provider store={ store }>
		<BrowserRouter basename={ siteData.site_base_path }>
			<Route path="/" component={ SiteContainer } />
		</BrowserRouter>
	</Provider>,

	document.getElementById( 'app' )
)
